import React from 'react';
import styled from 'styled-components';

import { PT_SERIF } from '../../../styles/typography';
import { Loading } from '../../Icon/Loading';
import { Tick } from '../../Icon/Tick';

const StyledSubmit = styled.button`
  cursor: pointer;
  font-family: ${PT_SERIF};
  text-decoration: none;
  background: #355834;
  color: #ffffff;
  font-size: 20px;
  border: 0;
  padding: 16px 16px;
  display: block;
  min-width: 200px;
  transition: background 0.2s ease-in-out;
  position: relative;
  height: 54px;
  &:hover {
    background: #274126;
  }
`;

const StyledLoading = styled(Loading)`
  display: block;
  margin: 0 auto;
  width: 50px;
  circle {
    fill: #fff;
  }
`;

const StyledSuccess = styled(Tick)`
  svg {
    fill: #fff;
  }
`;

const Submit = ({ className, loading, success, children }) => (
  <StyledSubmit className={className}>
    {loading && (
        <StyledLoading />
    )}
    {success && (
        <StyledSuccess />
    )}
    {!loading && !success && children}
  </StyledSubmit>
);

export default Submit;
